import React from "react";
import ReactDOM from "react-dom";
import { Route, Switch, Redirect } from "react-router-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";

import LoginForm from "./js/Components/Login";
import Contact from "./js/Components/Contact";
import Home from "./js/Components/Home";
import RecFormat from "./js/Components/RecFormat";
import GenerateReport from "./js/Components/GenerateReport";
import UnalCanvas from "./js/Basics/UnalCanvas";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("access") != null ? (
        <Component {...props} />
      ) : (
        <Redirect to="/" />
      )
    }
  />
);

const LoginRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("access") == null ? (
        <Component {...props} />
      ) : (
        <Redirect to="/home" />
      )
    }
  />
);

ReactDOM.render(
  <BrowserRouter basename={"/uapapp"}>
    <UnalCanvas>
      <Switch>
        <LoginRoute exact path="/" component={LoginForm} />
        <Route exact path="/contact" component={Contact} />
        <PrivateRoute exact path="/home" component={Home} />
        <PrivateRoute
          exact
          path="/generate_report"
          component={GenerateReport}
        />
        <PrivateRoute exact path="/rec_format" component={RecFormat} />
        <Route path="*" component={() => "404 NOT FOUND"}>
          {localStorage.getItem("access") != null ? (
            <Redirect to="/home" />
          ) : (
            <Redirect to="/" />
          )}
        </Route>
      </Switch>
    </UnalCanvas>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
